import type { WorkspaceProjection } from '@localagent/sdk';

export const WORKSPACE_READINESS_LABELS = [
  'Ready',
  'Waking',
  'Asleep',
  'Working',
  'Needs attention',
  'Archived',
] as const;

export type WorkspaceReadinessLabel = (typeof WORKSPACE_READINESS_LABELS)[number];

export function workspaceReadiness(projection: WorkspaceProjection): WorkspaceReadinessLabel {
  if (projection.lifecycle === 'archived' || projection.lifecycle === 'archiving') {
    return 'Archived';
  }
  if (projection.operation?.state === 'running') return 'Working';
  if (
    projection.filesystem.state === 'error' ||
    projection.workstation.status === 'error' ||
    projection.workstation.status === 'failed' ||
    projection.binding?.state === 'missing' ||
    projection.binding?.last_outcome?.status === 'needs_resolution' ||
    projection.binding?.last_outcome?.status === 'failed'
  ) {
    return 'Needs attention';
  }
  if (
    projection.workstation.status === 'starting' ||
    projection.workstation.status === 'pending' ||
    projection.filesystem.state === 'provisioning'
  ) {
    return 'Waking';
  }
  if (projection.workstation.status === 'sleeping') return 'Asleep';
  if (
    projection.filesystem.state === 'ready' &&
    (projection.workstation.status === 'running' || projection.workstation.status === 'connected')
  ) {
    return 'Ready';
  }
  return 'Needs attention';
}

export function WorkspaceReadiness({ projection }: { projection: WorkspaceProjection }) {
  const label = workspaceReadiness(projection);
  return (
    <span data-testid="workspace-readiness" className="rounded bg-muted px-1.5 py-0.5 text-xs font-medium">
      {label}
    </span>
  );
}
